import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {ITotalByPeople} from "../../../../../../../utils/interfaces/tannery_raw_material/ITotalByPeople";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";


const useApiGetTotalsByPeople = (
    companyToken: string | undefined,
    start_date: string | undefined,
    end_date: string | undefined
): UseQueryResult<ITotalByPeople[], CustomAxiosError> => {
    const {get} = useApiCalls()

    async function doGet(
        company_token: string | undefined): Promise<ITotalByPeople[]> {
        try {
            const response = await get(`/api/company/${company_token}/tannery_raw_material/lots/totals_by_people?start_date=${start_date}&end_date=${end_date}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ['useApiGetTotalsByPeople', start_date, end_date],
        queryFn: () => doGet(companyToken),
        enabled: !!companyToken && !!start_date && !!end_date,
    })

};

export default useApiGetTotalsByPeople